export enum BreakPointsMaxInPx {
  XS = 575,
  SM = 767,
  MD = 991,
  LG = 1199
}
